import { Box, CircularProgress, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const StatusBannerRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})(({ theme, statusColor }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  minHeight: 44,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  color: statusColor,
  borderRadius: theme.spacing(1.25),
  backgroundColor: alpha(statusColor, theme.palette.mode === 'dark' ? 0.075 : 0.045),
  border: '1px solid',
  borderColor: alpha(statusColor, theme.palette.mode === 'dark' ? 0.22 : 0.14),

  [theme.breakpoints.up('md')]: {
    minHeight: 48,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const StatusIconContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})(({ theme, statusColor }) => ({
  width: 30,
  height: 30,
  display: 'grid',
  placeItems: 'center',
  flex: '0 0 auto',
  borderRadius: '50%',
  backgroundColor: alpha(statusColor, theme.palette.mode === 'dark' ? 0.16 : 0.1),

  [theme.breakpoints.up('md')]: {
    width: 34,
    height: 34,
  },
}));

export const StatusBannerText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})(({ theme, statusColor }) => ({
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  color: statusColor,
  letterSpacing: 0,

  [theme.breakpoints.up('sm')]: {
    fontSize: 14,
  },
}));

export const StatusBannersRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: theme.spacing(1),
  width: '100%',
  padding: theme.spacing(1, 1.5),

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },

  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  '& > *': {
    flex: '1 1 50%',
    minWidth: 0,
  },
}));

export const StatusBannerProgress = styled(CircularProgress, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})(({ statusColor }) => ({
  flex: '0 0 auto',
  color: statusColor,
}));
